import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class CanonicalService {
    constructor(@Inject(DOCUMENT) private document: Document) {}

    setUrl(url: string): void {
        this.remove();

        const canonical = this.document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        canonical.setAttribute('href', url);
        this.document.head.appendChild(canonical);
    }

    remove(): void {
        this.document.querySelectorAll('link[rel="canonical"]').forEach(link => link.remove());
    }
}
